import { render } from "./CreateInvoice.vue?vue&type=template&id=678a0245"
import script from "./CreateInvoice.vue?vue&type=script&lang=js"
export * from "./CreateInvoice.vue?vue&type=script&lang=js"

import "./CreateInvoice.vue?vue&type=style&index=0&id=678a0245&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__